module.exports = __webpack_public_path__ + "static/media/computer_ventilator.1d7eeef8.png";